import styled from "styled-components";

const SearchContainer = styled.div`
  margin: 0px -21px;

  > div,
  > ul {
    max-width: 1137px;
    margin: 16px auto;
  }

  .StickyPromotionBar__timer {
    bottom: -16px !important;
    left: 200px !important;
    width: 100% !important;
    max-width: unset !important;
  }

  @media (max-width: 768px) {
    margin: 0px;

    .Container__regular {
      margin-bottom: 32px;
    }
  }

  .ReactivationBanner__container {
    margin-top: 0;
    margin-bottom: 16px;
  }
  .UpgradeButton__rightAlign {
    margin-right: 0;
  }

  .Header__HeaderContent {
    max-width: 1134px;
  }

  .CardDeclineError {
    margin-bottom: 16px;
  }

  .horizontal-menu {
    margin: 0 auto;
    max-width: 1134px;
  }
`;

const CollectionBanner = styled.img`
  width: 100%;
  object-fit: contain;
  margin-bottom: 26px;
`;

const CollectionContainer = styled.div`
  max-width: 1134px;
  text-align: center;
`;

const NoProductsFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  img {
    width: 42%;
  }
`;
const NoProductsFoundImage = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const MessageStyle = styled.div`
  margin-top: 64px;

  div:first-of-type {
    font-size: 22px;
    font-weight: 600;
    color: #000;
  }

  div:nth-of-type(2) {
    font-size: 14px;
    color: #6f7582;
    margin-top: 8px;
  }
`;

const TrendingCollectionsStyle = styled.div`
  .trending-collections__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .trending-collections__container a {
    cursor: pointer;
  }

  .trending-collections__container img {
    height: 100%;
    width: 100%;
    border-radius: 8px;
  }

  .trending-collections__container div {
    position: relative;
    width: calc(25% - 22px);
    box-shadow: 0 4px 19px 0 rgba(34, 41, 57, 0.15);
    border-radius: 8px;
  }

  @media (max-width: 990px) {
    .trending-collections__container {
      justify-content: space-around;
    }

    .trending-collections__container div {
      width: calc(50% - 100px);
      min-width: 237px;
    }

    .trending-collections__container div:nth-child(n + 3) {
      margin-top: 16px;
    }
    .trending-collections__container div:nth-child(n + 4) {
      margin-top: 16px;
    }
  }

  @media (max-width: 535px) {
    .trending-collections__container {
      justify-content: center;
    }

    .trending-collections__container div {
      width: calc(100% - 100px);
      margin-top: 8px;
      max-width: 264px;
    }

    .trending-collections__container div:nth-child(n + 3) {
      margin-top: 8px;
    }
    .trending-collections__container div:nth-child(n + 4) {
      margin-top: 8px;
    }
  }
`;

export {
  MessageStyle,
  SearchContainer,
  CollectionBanner,
  CollectionContainer,
  NoProductsFoundImage,
  TrendingCollectionsStyle,
  NoProductsFoundContainer
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/SearchStyle.js